import { defineComponent as _defineComponent } from 'vue'
import { renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, toDisplayString as _toDisplayString, createElementVNode as _createElementVNode } from "vue"

const _hoisted_1 = { class: "flex space-x-5 items-center" }
const _hoisted_2 = { class: "mk-label-small text-gray-500 leading-4 pb-2" }
const _hoisted_3 = { class: "mk-label-small text-gray-900 leading-4" }

interface HeaderItem {
  label: string;
  value: string;
}


export default /*#__PURE__*/_defineComponent({
  __name: 'TouchpointSubHeader',
  props: {
    items: null
  },
  setup(__props: any) {



return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(__props.items, (item) => {
      return (_openBlock(), _createElementBlock("div", {
        key: item.label + item.value
      }, [
        _createElementVNode("div", _hoisted_2, _toDisplayString(item.label), 1),
        _createElementVNode("div", _hoisted_3, _toDisplayString(item.value), 1)
      ]))
    }), 128))
  ]))
}
}

})